import { doc, getDoc, setDoc } from "firebase/firestore";
import { firestore } from "../firebase";

const resumeRef = doc(firestore, "Resume", "current");

function fileToDataUrl(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(file);
  });
}

export async function uploadResume(file) {
  const pdfData = await fileToDataUrl(file);

  await setDoc(resumeRef, {
    contentType: file.type || "application/pdf",
    fileName: file.name || "resume.pdf",
    pdfData,
    updatedAt: new Date(),
  });
}

export async function downloadResume() {
  const snapshot = await getDoc(resumeRef);

  if (!snapshot.exists()) {
    throw new Error("Resume not found.");
  }

  const { fileName = "resume.pdf", pdfData } = snapshot.data();
  const downloadLink = document.createElement("a");
  downloadLink.href = pdfData;
  downloadLink.download = fileName;
  document.body.appendChild(downloadLink);
  downloadLink.click();
  downloadLink.remove();
}
